module.exports = __webpack_public_path__ + "static/media/BAT.9c245d01.svg";